export default "__VITE_ASSET__DCLKsjev__"